import React from 'react';
import Icon, { Icons } from '../../../Icons/Icon';
import { container, icon, text } from './styles.module.css';

const DiscoveryInput = ({ locationName, onClick = () => {} }) => {
  return (
    <div className={container} onClick={onClick} onKeyPress={onClick}>
      <Icon icon={Icons.SEARCH.BLACK} className={icon} />
      <span className={text}>{locationName}</span>
    </div>
  );
};

export default DiscoveryInput;
